import React from 'react'
import { BrowserRouter, Switch, Route, Redirect} from 'react-router-dom'
import Layout from './layout'
import Home from '../pages/home'
import Product from '../pages/product'
import Products from '../pages/products'
import Contact from '../pages/contact'
import './App.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'react-animation/dist/keyframes.css'
import Analytics from '../pages/admin/analytics'
import AdminEmpresa from '../pages/admin/empresa'
import AdminProducts from '../pages/admin/products'
import AdminProductsCategories from '../pages/admin/categories'
import AdminEditProduct from '../pages/admin/products/edit'
import UsuarioObj from '../utils/usuario'
const user = new UsuarioObj()

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={(props) => (
    user.userLogged ?
       <Component {...props} />
      :
        <Redirect to='/' />
  )} />
)

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Switch>
          <PrivateRoute exact path="/admin/analytics/" component={Analytics} />
          <PrivateRoute exact path="/admin/empresa/" component={AdminEmpresa} />
          <PrivateRoute exact path="/admin/productos/" component={AdminProducts} />
          <PrivateRoute exact path="/admin/categorias/" component={AdminProductsCategories} />
          <PrivateRoute exact path="/admin/productos/editar/:id" component={AdminEditProduct} />
          <PrivateRoute exact path="/admin/productos/nuevo/" component={AdminEditProduct} />
          <Route exact path="/" component={Home} />
          <Route exact path="/productos" component={Products} />
          <Route exact path="/productos/:categoria" component={Products} />
          <Route exact path="/producto/:id" component={Product} />
          <Route exact path="/contacto" component={Contact} />
          <Route exact path="/contacto/:productId" component={Contact} />
          {/* <Route component={NotFound} /> */}
        </Switch>
      </Layout>
    </BrowserRouter>
  )
}

export default App;
